import type { RackAssignmentViewModel } from '@api/bff/rackAssignments/useRackAssignments';
import type { WorkOrderRunCellRequest } from './useRuns';

export const buildRunCells = (
  rackAssignment: RackAssignmentViewModel | undefined | null
): WorkOrderRunCellRequest[] =>
  (rackAssignment?.cells ?? [])
    .filter(cell => !!cell.scriptGlobalId)
    .map(cell => ({
      cell: cell.cell,
      scriptGlobalId: cell.scriptGlobalId,
      equipmentRef: cell.equipmentRef ? { globalId: cell.equipmentRef } : null
    }));
